module.exports = __webpack_public_path__ + "img/uc_idx_banner.1ee14689.jpg";